import { globalActions, loginActions } from 'primary-components';

import properties from 'resources/constants/properties.json';
import LocalStorageUtils from 'utils/LocalStorageUtils';
import { defaultThrottledFetch } from 'utils/ThrottleUtils';

// we can not use one from AuthUtils
// const enableLogInButton = async () => {
//   await ExcelUtils.switchButton({ tabId: "NG.Tab1", groupId: "NG.Tab1.Group3", buttonId: "NG.LogIn", enabled: true })
//   await ExcelUtils.switchButton({ tabId: "NG.Tab1", groupId: "NG.Tab1.Group3", buttonId: "NG.LogOut", enabled: false })
//   await ExcelUtils.switchButton({ tabId: "NG.Tab1", groupId: "NG.Tab1.Group1", buttonId: "NG.DataLakeButton", enabled: false })
//   await ExcelUtils.switchButton({ tabId: "NG.Tab1", groupId: "NG.Tab1.Group1", buttonId: "NG.TimeSeriesButton", enabled: false })
//   await ExcelUtils.switchButton({ tabId: "NG.Tab1", groupId: "NG.Tab1.Group2", buttonId: "NG.RefreshCell", enabled: false })
//   await ExcelUtils.switchButton({ tabId: "NG.Tab1", groupId: "NG.Tab1.Group2", buttonId: "NG.RefreshSheet", enabled: false })
//   await ExcelUtils.switchButton({ tabId: "NG.Tab1", groupId: "NG.Tab1.Group2", buttonId: "NG.RefreshAll", enabled: false })
//   await ExcelUtils.switchButton({ tabId: "NG.Tab1", groupId: "NG.Tab1.Group2", buttonId: "NG.UploadButton", enabled: false })
// }

const FUNCTIONS_NAMESPACE = properties.functionsNamespace
const getAuthToken = () => (dispatch, getState) => getState().primaryComponentsState.loginState.token 

const getApiConfig = ({ fetchOverride } = {}) => dispatch => ({                  
  getAuthToken: () => dispatch(getAuthToken()),
  handleRequest: (...params) => {
    if(globalActions?.handleRequest) {
      return dispatch(globalActions?.handleRequest(...params))
    }
    return undefined;
  },
  onLogOut: () => {
    LocalStorageUtils.clearLocalStorage()
    window["ngStore" + FUNCTIONS_NAMESPACE].dispatch(loginActions.logOutResponse())
    // enableLogInButton()
  },
  baseUrl: LocalStorageUtils.getApiUrl(),
  clearLocalStorage: () => {
    LocalStorageUtils.clearLocalStorage()
    window["ngStore" + FUNCTIONS_NAMESPACE].dispatch(loginActions.logOutResponse())
    // enableLogInButton()
  },
  fetch: fetchOverride || defaultThrottledFetch
})

export default getApiConfig;
